import { useEffect, useRef, useState } from 'react';

const MIN_LOADER_TIME = 300;

const useLoadingEffect = (isLoading, delay = MIN_LOADER_TIME) => {
  const [loadingVisible, setLoadingVisible] = useState(false);
  const startTimeRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (isLoading) {
      startTimeRef.current = Date.now();
      setLoadingVisible(true);
      return;
    }

    const elapsed = Date.now() - startTimeRef.current;
    const remaining = Math.max(delay - elapsed, 0);

    timeoutRef.current = setTimeout(() => {
      setLoadingVisible(false);
    }, remaining);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isLoading]);

  return { loadingVisible };
};

export default useLoadingEffect;
